export const status = [
    { id: 0, name: 'Inactive' },
    { id: 1, name: 'Active' },
];